import React from "react";
import styles from "./menu-lateral-btn.module.css";

type Props = {
  onHandleTab: (tab: string) => string;
  onClickLogout: () => void;
  icon: JSX.Element;
  title: string;
};

const BtnMenuLogout = ({ onHandleTab, onClickLogout, icon, title }: Props) => {
  return (
    <li className={onHandleTab(title)} onClick={onClickLogout}>
      <div className={styles.btnContainer}>
        {icon}
        <span>{title}</span>
      </div>
    </li>
  );
};

export default BtnMenuLogout;
